import { render, staticRenderFns } from "./RegistrationStatsView.vue?vue&type=template&id=4e866466&"
import script from "./RegistrationStatsView.vue?vue&type=script&lang=ts&"
export * from "./RegistrationStatsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports